import { render, staticRenderFns } from "./DonutChart90.vue?vue&type=template&id=0a7f36a1&scoped=true"
import script from "./DonutChart90.vue?vue&type=script&lang=js"
export * from "./DonutChart90.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f36a1",
  null
  
)

export default component.exports